module.exports = __webpack_public_path__ + "img/full7-min.50c3785f.png";